import { render, staticRenderFns } from "./UploadContacts.vue?vue&type=template&id=440b0388"
import script from "./UploadContacts.vue?vue&type=script&lang=js"
export * from "./UploadContacts.vue?vue&type=script&lang=js"
import style0 from "./UploadContacts.vue?vue&type=style&index=0&id=440b0388&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports